var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "result",
      class: { "result--selected": _vm.isSelected },
      attrs: { type: "button", "aria-label": _vm.item.companyName },
      on: { click: _vm.handleClick },
    },
    [
      _vm.item.country
        ? _c("img", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: _vm.item.country.name,
                expression: "item.country.name",
              },
            ],
            staticClass: "result__flag",
            attrs: {
              src: _vm.item.country.flagUrl,
              alt: _vm.item.country.name,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", {
        staticClass: "result__name",
        attrs: { title: _vm.item.companyName },
        domProps: { textContent: _vm._s(_vm.item.companyName) },
      }),
      _vm._v(" "),
      _vm.item.sectors.length
        ? _c("span", { staticClass: "result__sector" }, [
            _c("span", {
              staticClass: "sector",
              attrs: { title: _vm.item.sectors[0].name },
              domProps: { textContent: _vm._s(_vm.item.sectors[0].name) },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.item.shortType
        ? _c("span", { staticClass: "result__type" }, [
            _c("span", {
              staticClass: "sector",
              attrs: { title: _vm.item.shortType },
              domProps: { textContent: _vm._s(_vm.item.shortType) },
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }